const SELECTOR = '[data-result-map-view]';
const SELECTOR_ITEM = '[data-result-map-view-item]';
const SELECTOR_DATA_CENTER_LAT_VALUE = '[data-center-lat-value]';
const SELECTOR_DATA_CENTER_LNG_VALUE = '[data-center-lng-value]';
const SELECTOR_DATA_ZOOM_VALUE = '[data-zoom-value]';
const SELECTOR_DATA_MAP_ICON_VALUE = '[data-map-icon-value]';

class GoogleMapSearchResult {
  constructor() {
    if ($(SELECTOR).size() && $(SELECTOR_ITEM).size()) {
      this.attachEventHandlers();
    }
  }

  attachEventHandlers() {
    var $centerLat = parseFloat($(SELECTOR_DATA_CENTER_LAT_VALUE).val());
    var $centerLng = parseFloat($(SELECTOR_DATA_CENTER_LNG_VALUE).val());
    var $mapIcon = $(SELECTOR_DATA_MAP_ICON_VALUE).val();
    var $defaultZoom = parseInt($(SELECTOR_DATA_ZOOM_VALUE).val());
    var marker;
    var i;
    var map = new google.maps.Map($(SELECTOR)[0], {
      zoom: $defaultZoom,
      center: { lat: $centerLat, lng: $centerLng },
      maxZoom: 12,
      streetViewControl: false,
      mapTypeControl: false
    });
    $(SELECTOR_ITEM).each(function() {
      if ($(this).data('lat-value') && $(this).data('lon-value')) {
        var marker_icon = $mapIcon;
        var anchor = `#user-${$(this).data('user-id')}`;
        marker = new google.maps.Marker({
          position: new google.maps.LatLng(
            $(this).data('lat-value'),
            $(this).data('lon-value')
          ),
          map: map,
          icon: marker_icon,
          url: anchor
        });
        google.maps.event.addListener(
          marker,
          'click',
          (function(marker, i) {
            return function() {
              var elem = $(marker.url);
              $('html, body').animate(
                {
                  scrollTop: elem.offset().top
                },
                600
              );
              $(anchor)
                .animate({ backgroundColor: '#eef4f8' }, 1000)
                .animate({ backgroundColor: 'transparent' }, 1000);
            };
          })(marker, i)
        );
      }
    });
  }
}

export default GoogleMapSearchResult;



// WEBPACK FOOTER //
// ./src/javascripts/GoogleMapSearchResult.js